import formConfig from './psfa';

const expectedOrders: Record<string, string[]> = {
  'department-select': [
    'department',
    'sub_organisation',
    'department_id',
    'organisation_id',
    'report-period',
    'submitter_name',
    'submitter_email',
    'senior_officer_name',
    'senior_officer_email',
    'board_member_name',
    'board_member_email',
  ],
  'prevented-actual-add-instance': [
    'prevented_actual_area',
    'prevented_actual_deception',
    'prevented_actual_support',
    'prevented_actual_support_additional',
    'prevented_actual_c19',
    'prevented_actual_impact',
    'prevented_actual',
    'prevented_actual_comments',
  ],
  'prevented-fraud-add-instance': [
    'prevented_future_fraud_area',
    'prevented_future_fraud_deception',
    'prevented_future_fraud_support',
    'prevented_future_fraud_support_additional',
    'prevented_future_fraud_c19',
    'prevented_future_fraud_impact',
    'prevented_future_fraud',
    'prevented_future_fraud_methodology_number',
    'prevented_future_fraud_comments',
  ],
  'prevented-error-add-instance': [
    'prevented_future_error_area',
    'prevented_future_error_responsible',
    'prevented_future_error_involved',
    'prevented_future_error_c19',
    'prevented_future_error_impact',
    'prevented_future_error',
    'prevented_future_error_methodology_number',
    'prevented_future_error_comments',
  ],
  'detected-fraud-add-instance': [
    'detected_fraud_area',
    'detected_fraud_committed',
    'detected_fraud_deception',
    'detected_fraud_support',
    'detected_fraud_support_additional',
    'detected_fraud_c19',
    'detected_fraud_input',
    'detected_fraud',
    'detected_fraud_comments',
  ],
  'detected-error-add-instance': [
    'detected_error_area',
    'detected_error_responsible',
    'detected_error_c19',
    'detected_error_impact',
    'detected_error',
    'detected_error_comments',
  ],
  'detected-bribery': [
    'detected_bribery_c19',
    'detected_bribery_instances',
    'detected_bribery',
    'detected_bribery_comments',
  ],
  'recovered-fraud-add-instance': [
    'recovered_fraud_area',
    'recovered_fraud_committed',
    'recovered_fraud_deception',
    'recovered_fraud_support',
    'recovered_fraud_c19',
    'recovered_fraud_impact',
    'recovered_fraud',
    'recovered_fraud_comments',
  ],
  'recovered-error-add-instance': [
    'recovered_error_area',
    'recovered_error_deception',
    'recovered_error_recovered',
    'recovered_error_c19',
    'recovered_error_impact',
    'recovered_error',
    'recovered_error_comments',
  ],
};

test.each(Object.entries(expectedOrders))('%s follows CDR v1.2 field order', (name, expected) => {
  const page = formConfig.sections
    .flatMap((section) => section.subsections.flatMap((subsection) => subsection.pages))
    .find((page) => page.name === name);
  if (!page || !('questions' in page) || !page.questions)
    throw new Error(`Missing question page: ${name}`);
  expect(page.questions.map((question) => question.name)).toEqual(expected);
});
